import { useMemo } from 'react';
import { themeMaterial } from 'ag-grid-community';
import { useTheme } from '@mui/material';
import { alpha, lighten } from '@mui/material/styles';

const useAgGridTheme = () => {
  const theme = useTheme();

  return useMemo(
    () =>
      themeMaterial.withParams({
        fontFamily: theme.typography.fontFamily,
        fontSize: 14,
        primaryColor: theme.palette.primary.main,
        accentColor: theme.palette.primary.main,
        invalidColor: theme.palette.error.main,
        backgroundColor: theme.palette.common.white,
        dataBackgroundColor: 'transparent',
        foregroundColor: theme.palette.text.primary,
        borderColor: theme.palette.grey[300],
        borderRadius: 4,

        headerBackgroundColor: theme.palette.grey[100],
        headerTextColor: theme.palette.text.primary,
        headerCellHoverBackgroundColor: theme.palette.grey[100],

        rowHoverColor: '#f5f5f5',
        selectedRowBackgroundColor: lighten(theme.palette.primary.main, 0.9),

        checkboxUncheckedBorderColor: theme.palette.action.active,
        checkboxIndeterminateBackgroundColor: theme.palette.action.active,
        checkboxIndeterminateBorderColor: 'transparent',

        rangeSelectionBorderColor: theme.palette.primary.main,

        buttonBorderRadius: 100,
        buttonHorizontalPadding: theme.spacing(1.25),
        buttonVerticalPadding: theme.spacing(0.5),
        buttonHoverBackgroundColor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),

        statusBarValueColor: theme.palette.text.primary,

        focusShadow: 'none',

        tooltipTextColor: theme.palette.common.white,
        tooltipBackgroundColor: theme.palette.grey[800],
        tooltipBorder: 'none',

        iconButtonBorderRadius: 10,
      }),
    [theme],
  );
};

export default useAgGridTheme;
